<header>
  <div class="header-icons">
    <h2>{{ "taxReturns.Warnings-Flags-Comments" | transloco }}</h2>
    <div id="icons">
      <div
        (click)="selectTab(1)"
        class="notification-icon warnings-highlighted"
        [ngClass]="{ active: tab == 1 }"
      ></div>

      <div
        (click)="selectTab(2)"
        class="notification-icon flags-highlighted"
        [ngClass]="{ active: tab == 2 }"
      ></div>

      <div
        (click)="selectTab(3)"
        class="notification-icon comments-highlighted"
        [ngClass]="{ active: tab == 3 }"
      ></div>
    </div>
  </div>

  <div class="header-flex">
    @if (tab === 1) {
    <div class="empty-questions-toggle">
      <div class="ui slider checkbox">
        <input
          type="checkbox"
          name="toggle"
          (click)="updateFlag($event.target.checked, tab)"
          checked
        />
        @if (showActiveAnswerWarnings) {
        <label>{{ "taxReturns.showing-active-warnings" | transloco }}</label>
        } @if (!showActiveAnswerWarnings) {
        <label>{{ "taxReturns.showing-closed-warnings" | transloco }}</label>
        }
      </div>
    </div>
    } @if (tab === 2) {
    <div class="empty-questions-toggle">
      <div class="ui slider checkbox">
        <input
          type="checkbox"
          name="toggle"
          (click)="updateFlag($event.target.checked, tab)"
          checked
        />
        @if (showActiveAnswerWarnings) {
        <label>{{ "taxReturns.showing-active-flags" | transloco }}</label>
        } @if (!showActiveAnswerWarnings) {
        <label>{{ "taxReturns.showing-closed-flags" | transloco }}</label>
        }
      </div>
    </div>
    }
  </div>
</header>

@if (!taxReturnWithMissingInfo) {
<div class="ui active centered inline loader"></div>
} @if (taxReturnWithMissingInfo && tab === 1) {
<div class="body">
  @if (( taxReturnWithMissingInfo && taxReturnWithMissingInfo.categories.length
  === 0) || !hasWarnings) {
  <div class="no-warnings-info">{{ "taxReturns.no-warnings" | transloco }}</div>
  }
  <div class="left-bar">
    @for (category of taxReturnWithMissingInfo.categories; track category) {
    <div class="category">
      @if (showitem(category, tab)) {
      <div class="count">
        <div
          class="title"
          (click)="category.isCollapsed = !category.isCollapsed"
        >
          <i
            class="chevron icon"
            [ngClass]="{
              down: category.isCollapsed,
              up: !category.isCollapsed
            }"
          ></i>
          {{ category.name }}
        </div>
        @for (subCategory of category.subcategories; track subCategory) {
        <div [hidden]="category.isCollapsed" class="subcategory">
          @if (showitem(subCategory, tab)) {
          <div>
            <div
              class="title"
              (click)="subCategory.isCollapsed = !subCategory.isCollapsed"
            >
              <i
                class="chevron icon"
                [ngClass]="{
                  down: subCategory.isCollapsed,
                  up: !subCategory.isCollapsed
                }"
              ></i>
              {{ subCategory.name }}
            </div>
            @for (group of subCategory.groups; track group) {
            <div [hidden]="subCategory.isCollapsed" class="group">
              @if (showitem(group, tab)) {
              <div>
                @if (group.id) {
                <div
                  class="title"
                  (click)="group.isCollapsed = !group.isCollapsed"
                >
                  <i
                    class="chevron icon"
                    [ngClass]="{
                      down: group.isCollapsed,
                      up: !group.isCollapsed
                    }"
                  ></i>
                  {{ group.name }}
                </div>
                } @for (subGroup of group.subgroups; track subGroup) {
                <div [hidden]="group.isCollapsed" class="subgroup">
                  @if (showitem(subGroup, tab) && !subGroup.isTable) {
                  <div>
                    <div
                      class="title"
                      (click)="subGroup.isCollapsed = !subGroup.isCollapsed"
                    >
                      <i
                        class="chevron icon"
                        [ngClass]="{
                          down: subGroup.isCollapsed,
                          up: !subGroup.isCollapsed
                        }"
                      ></i>
                      {{ subGroup.name }}
                    </div>
                    @for (_question of subGroup.questions; track _question) {
                    <div [hidden]="subGroup.isCollapsed">
                      @if (hasValidationWarnings(category, _question) ||
                      hasMissingInfoWarnings(category, _question, tab)) {
                      <div
                        class="question"
                        [ngClass]="{
                          active:
                            _question.id === question?.id &&
                            question.category?.id === category?.id &&
                            question.subcategory?.id === subCategory?.id &&
                            (group.id
                              ? question.group?.id === group?.id
                              : true) &&
                            question.subgroup?.id === subGroup?.id
                        }"
                      >
                        <span
                          (click)="
                            selectQuestion(
                              _question,
                              category,
                              subCategory,
                              group,
                              subGroup,
                              tab
                            )
                          "
                        >
                          {{ _question.id }}.&nbsp;{{ _question.question }}
                        </span>
                        @if ( _question.id===question?.id &&
                        question.category?.id===category?.id &&
                        question.subcategory?.id===subCategory?.id && (group.id
                        ? question.group?.id===group?.id : true) &&
                        question.subgroup?.id===subGroup?.id) {
                        <span
                          (click)="
                            goToSection(
                              _question,
                              category,
                              subCategory,
                              group,
                              subGroup
                            )
                          "
                        >
                          &#8618;
                          {{ "taxReturns.go-to-section-no-arrow" | transloco }}
                        </span>
                        }
                      </div>
                      }
                    </div>
                    }
                  </div>
                  } @if (showitem(subGroup, tab) && subGroup.isTable) {
                  <div>
                    <div
                      class="title"
                      (click)="subGroup.isCollapsed = !subGroup.isCollapsed"
                    >
                      <i
                        class="chevron icon"
                        [ngClass]="{
                          down: subGroup.isCollapsed,
                          up: !subGroup.isCollapsed
                        }"
                      ></i>
                      {{ subGroup.name }}
                    </div>
                    <div [hidden]="subGroup.isCollapsed">
                      <div
                        class="question"
                        [ngClass]="{
                          active:
                            subGroup.question.id === question?.id &&
                            question.category?.id === category?.id &&
                            question.subcategory?.id === subCategory?.id &&
                            (group.id
                              ? question.group?.id === group?.id
                              : true) &&
                            question.subgroup?.id === subGroup?.id
                        }"
                      >
                        <span
                          (click)="
                            selectQuestion(
                              subGroup.question,
                              category,
                              subCategory,
                              group,
                              subGroup,
                              tab
                            )
                          "
                        >
                          {{ subGroup.question.id }}.&nbsp;{{
                            subGroup.question.question
                          }}
                        </span>
                        @if ( subGroup.question.id===question?.id &&
                        question.category?.id===category?.id &&
                        question.subcategory?.id===subCategory?.id && (group.id
                        ? question.group?.id===group?.id : true) &&
                        question.subgroup?.id===subGroup?.id) {
                        <span
                          (click)="
                            goToSection(
                              subGroup.questions[0],
                              category,
                              subCategory,
                              group,
                              subGroup
                            )
                          "
                        >
                          &#8618;
                          {{ "taxReturns.go-to-section-no-arrow" | transloco }}
                        </span>
                        }
                      </div>
                    </div>
                  </div>
                  }
                </div>
                }
              </div>
              }
            </div>
            }
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
  @if (question && hasWarnings) {
  <div class="main-content">
    <header>
      <h3>{{ question?.id }}.&nbsp;{{ question?.question }}</h3>
    </header>
    <div class="list-container">
      @if (question) {
      <div class="list-inner-cont">
        @if (question.displayFieldType !== 'table' && !question.parentId) {
        <div class="display-answer">
          @if (question) {
          <app-form-field-wrapper
            [disabled]="true"
            [formGroup]="formGroup"
            [question]="question"
            [showHiddenQuestion]="true"
          >
          </app-form-field-wrapper>
          }
        </div>
        } @if (question.displayFieldType === 'table') {
        <div class="display-answer">
          <app-modern-table
            [columnOrdering]="columnOrdering"
            [subGroup]="subGroup"
            [formGroup]="formGroup"
            [groupId]="groupId"
            [readonly]="true"
            [taxReturnId]="taxReturnId"
            [isVisible]="true"
            [hideFullScreen]="true"
          >
          </app-modern-table>
        </div>
        } @if (question.validationWarning) {
        <div class="flag-item">
          <div class="comment">
            <div class="header">
              <div class="ui label">{{ "taxReturns.warning" | transloco }}</div>
            </div>
            <div class="labels">
              <div class="ui label">
                {{ question?.id }}.&nbsp;{{ question?.question }}
              </div>
            </div>
            @if (question?.validationWarning?.warningMessage) {
            <div class="answer label">
              {{ question?.validationWarning?.warningMessage }}
            </div>
            }
          </div>
        </div>
        }
        <ng-container>
          @for (answerWarning of answerWarnings|orderBy:['status']:['asc'];
          track answerWarning) {
          <div>
            <div
              class="warning-item"
              [ngClass]="{
                disabled:
                  showActiveAnswerWarnings && answerWarning?.status !== 0
              }"
            >
              <div class="header">
                <div class="warning-type">
                  <div class="ui orange label">Review</div>
                  {{ answerWarning?.warning?.message }}
                </div>
                <div class="warning-date">
                  {{ answerWarning?.createdAtString }}
                </div>
              </div>
              <div class="labels">
                <span class="ui label"
                  >{{ answerWarning?.question }}@if (answerWarning?.rowIndex) {
                  <span> (row - {{ answerWarning?.rowIndex }})</span>
                  }</span
                >
                @if (answerWarning?.answer?.answer) {
                <span class="answer label">{{
                  answerWarning?.answer?.answer
                }}</span>
                }
              </div>
              <pre class="warning-message">{{
                answerWarning?.warningMessage
              }}</pre>
              @for (comment of answerWarning.replies; track comment) {
              <div class="comment">
                <div class="commenter-name">{{ comment?.author }}</div>
                <div class="commenter-role">
                  <div>
                    <i
                      class="small circle icon"
                      [ngClass]="{
                        preparer: comment?.role === 'Preparer',
                        reviewer: comment?.role === 'Reviewer'
                      }"
                    ></i>
                    {{ comment?.role }}
                  </div>
                  <div class="comment-date">{{ comment?.date }}</div>
                </div>
                <div class="comment-text">
                  <app-comment
                    [comment]="comment"
                    [documents]="taxReturn.documents"
                  ></app-comment>
                </div>
              </div>
              }
              <div class="reply-comment">
                @if (answerWarning?.replyTo) {
                <div>
                  <app-attachments
                    [(ngModel)]="answerWarning.replyComment"
                  ></app-attachments>
                  <div class="actions-btn-cont">
                    <div style="flex:1"></div>
                    <span
                      (click)="cancelReply(answerWarning)"
                      class="cancel-reply"
                      >{{ "taxReturns.cancel" | transloco }}</span
                    >
                    <span
                      (click)="
                        saveAnsWarningReply(
                          answerWarning,
                          answerWarning.replyComment
                        )
                      "
                      class="reply-only"
                      [ngClass]="{
                        disabled:
                          !answerWarning.replyComment.message || replyingWarning
                      }"
                      >{{ "taxReturns.reply-only" | transloco }}</span
                    >
                    <div
                      (click)="
                        saveAnsWarningReply(
                          answerWarning,
                          answerWarning.replyComment,
                          true
                        )
                      "
                      class="ui primary background button"
                      [ngClass]="{
                        disabled:
                          !answerWarning.replyComment.message || replyingWarning
                      }"
                    >
                      {{ "taxReturns.reply-and-close" | transloco }}
                    </div>
                  </div>
                </div>
                }
              </div>
              <div class="buttons">
                @if (answerWarning?.status == 0 && !answerWarning?.replyTo &&
                !readonly()) {
                <div (click)="answerWarning.replyTo = true" class="respond">
                  {{ "taxReturns.reply" | transloco }}
                </div>
                } @if (showSendToClientButton(answerWarning, question)) {
                <div class="send-to-client">
                  <i class="arrow up icon"></i>
                  <span>{{ "taxReturns.Send-to-Client" | transloco }}</span>
                </div>
                }
                <!-- <div *ngIf="answerWarning.externalUrl" class="view-in-oneteam">
                        <i class="external alternate icon"></i> <a [href]="answerFlag.externalUrl" target="_blank">{{ 'taxReturns.View-in-OneTeam' | transloco }}</a>
                      </div> -->
              </div>
            </div>
          </div>
          }
        </ng-container>
      </div>
      }
    </div>
  </div>
  }
</div>
} @if (taxReturnWithMissingInfo && tab === 2) {
<div class="body">
  @if (( taxReturnWithMissingInfo && taxReturnWithMissingInfo.categories.length
  === 0) || !hasWarnings) {
  <div class="no-warnings-info">{{ "taxReturns.no-warnings" | transloco }}</div>
  }
  <div class="left-bar">
    @for (category of taxReturnWithMissingInfo.categories; track category) {
    <div class="category">
      @if (showitem(category, tab)) {
      <div class="count">
        <div
          class="title"
          (click)="category.isCollapsed = !category.isCollapsed"
        >
          <i
            class="chevron icon"
            [ngClass]="{
              down: category.isCollapsed,
              up: !category.isCollapsed
            }"
          ></i>
          {{ category.name }}
        </div>
        @for (subCategory of category.subcategories; track subCategory) {
        <div [hidden]="category.isCollapsed" class="subcategory">
          @if (showitem(subCategory, tab)) {
          <div>
            <div
              class="title"
              (click)="subCategory.isCollapsed = !subCategory.isCollapsed"
            >
              <i
                class="chevron icon"
                [ngClass]="{
                  down: subCategory.isCollapsed,
                  up: !subCategory.isCollapsed
                }"
              ></i>
              {{ subCategory.name }}
            </div>
            @for (group of subCategory.groups; track group) {
            <div [hidden]="subCategory.isCollapsed" class="group">
              @if (showitem(group, tab)) {
              <div>
                @if (group.id) {
                <div
                  class="title"
                  (click)="group.isCollapsed = !group.isCollapsed"
                >
                  <i
                    class="chevron icon"
                    [ngClass]="{
                      down: group.isCollapsed,
                      up: !group.isCollapsed
                    }"
                  ></i>
                  {{ group.name }}
                </div>
                } @for (subGroup of group.subgroups; track subGroup) {
                <div [hidden]="group.isCollapsed" class="subgroup">
                  @if (showitem(subGroup, tab) && !subGroup.isTable) {
                  <div>
                    <div
                      class="title"
                      (click)="subGroup.isCollapsed = !subGroup.isCollapsed"
                    >
                      <i
                        class="chevron icon"
                        [ngClass]="{
                          down: subGroup.isCollapsed,
                          up: !subGroup.isCollapsed
                        }"
                      ></i>
                      {{ subGroup.name }}
                    </div>
                    @for (_question of subGroup.questions; track _question) {
                    <div [hidden]="subGroup.isCollapsed">
                      @if (hasMissingInfoWarnings(category, _question, tab)) {
                      <div
                        class="question"
                        [ngClass]="{
                          active:
                            _question.id === question?.id &&
                            question.category?.id === category?.id &&
                            question.subcategory?.id === subCategory?.id &&
                            (group.id
                              ? question.group?.id === group?.id
                              : true) &&
                            question.subgroup?.id === subGroup?.id
                        }"
                      >
                        <span
                          (click)="
                            selectQuestion(
                              _question,
                              category,
                              subCategory,
                              group,
                              subGroup,
                              tab
                            )
                          "
                        >
                          {{ _question.id }}.&nbsp;{{ _question.question }}
                        </span>
                        @if ( _question.id===question?.id &&
                        question.category?.id===category?.id &&
                        question.subcategory?.id===subCategory?.id && (group.id
                        ? question.group?.id===group?.id : true) &&
                        question.subgroup?.id===subGroup?.id) {
                        <span
                          (click)="
                            goToSection(
                              _question,
                              category,
                              subCategory,
                              group,
                              subGroup
                            )
                          "
                        >
                          &#8618;
                          {{ "taxReturns.go-to-section-no-arrow" | transloco }}
                        </span>
                        }
                      </div>
                      }
                    </div>
                    }
                  </div>
                  } @if (showitem(subGroup, tab) && subGroup.isTable) {
                  <div>
                    <div
                      class="title"
                      (click)="subGroup.isCollapsed = !subGroup.isCollapsed"
                    >
                      <i
                        class="chevron icon"
                        [ngClass]="{
                          down: subGroup.isCollapsed,
                          up: !subGroup.isCollapsed
                        }"
                      ></i>
                      {{ subGroup.name }}
                    </div>
                    <div [hidden]="subGroup.isCollapsed">
                      <div
                        class="question"
                        [ngClass]="{
                          active:
                            subGroup.question.id === question?.id &&
                            question.category?.id === category?.id &&
                            question.subcategory?.id === subCategory?.id &&
                            (group.id
                              ? question.group?.id === group?.id
                              : true) &&
                            question.subgroup?.id === subGroup?.id
                        }"
                      >
                        <span
                          (click)="
                            selectQuestion(
                              subGroup.question,
                              category,
                              subCategory,
                              group,
                              subGroup,
                              tab
                            )
                          "
                        >
                          {{ subGroup.question.id }}.&nbsp;{{
                            subGroup.question.question
                          }}
                        </span>
                        @if ( subGroup.question.id===question?.id &&
                        question.category?.id===category?.id &&
                        question.subcategory?.id===subCategory?.id && (group.id
                        ? question.group?.id===group?.id : true) &&
                        question.subgroup?.id===subGroup?.id) {
                        <span
                          (click)="
                            goToSection(
                              subGroup.question,
                              category,
                              subCategory,
                              group,
                              subGroup
                            )
                          "
                        >
                          &#8618;
                          {{ "taxReturns.go-to-section-no-arrow" | transloco }}
                        </span>
                        }
                      </div>
                    </div>
                  </div>
                  }
                </div>
                }
              </div>
              }
            </div>
            }
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
  @if (question && hasWarnings) {
  <div class="main-content">
    <header>
      <h3>{{ question?.id }}.&nbsp;{{ question?.question }}</h3>
    </header>
    <div class="list-container">
      <div class="list-inner-cont">
        @if (question.displayFieldType !== 'table' && !question.parentId) {
        <div class="display-answer">
          @if (question) {
          <app-form-field-wrapper
            [disabled]="true"
            [formGroup]="formGroup"
            [question]="question"
            [showHiddenQuestion]="true"
          >
          </app-form-field-wrapper>
          }
        </div>
        } @if (question.displayFieldType === 'table') {
        <div class="display-answer">
          <app-modern-table
            [columnOrdering]="columnOrdering"
            [subGroup]="subGroup"
            [formGroup]="formGroup"
            [groupId]="groupId"
            [readonly]="true"
            [taxReturnId]="taxReturnId"
            [isVisible]="true"
            [hideFullScreen]="true"
          >
          </app-modern-table>
        </div>
        }
        <ng-container>
          @for (answerFlag of initAnswerFlags|orderBy:['status']:['asc']; track
          answerFlag) {
          <div
            class="flag-item"
            [ngClass]="{
              disabled: showActiveAnswerWarnings && answerFlag?.status > 0
            }"
          >
            <div class="comment">
              <div class="header">
                <div class="ui label">
                  {{ answerFlag.flag.flagMessage }}
                </div>
                <div class="commenter-name">
                  {{ answerFlag?.parentComment?.author }}
                </div>
                <div class="date">{{ answerFlag?.parentComment?.date }}</div>
              </div>
              <div class="commenter-role">
                <div>
                  <i
                    class="small circle icon"
                    [ngClass]="{
                      preparer: answerFlag?.parentComment?.role === 'Preparer',
                      reviewer: answerFlag?.parentComment?.role === 'Reviewer'
                    }"
                  ></i>
                  {{ answerFlag?.parentComment?.role }}
                </div>
                <div class="comment-date">
                  {{ answerFlag?.parentComment?.createdAtString }}
                </div>
              </div>
              <div class="labels">
                <span class="ui label"
                  >{{ answerFlag?.question?.question }}@if
                  (answerFlag?.rowIndex) {
                  <span> (row - {{ answerFlag?.rowIndex }})</span>
                  }</span
                >
                @if (answerFlag?.answer?.answer) {
                <span class="answer label">{{
                  answerFlag?.answer?.answer
                }}</span>
                }
              </div>
              @if (answerFlag.parentComment) {
              <div class="comment-text">
                <app-comment
                  [comment]="answerFlag.parentComment"
                  [documents]="taxReturn.documents"
                ></app-comment>
              </div>
              } @for (comment of answerFlag?.parentComment?.comments; track
              comment) {
              <div class="reply comment">
                <div class="header">
                  <div class="commenter-name">{{ comment?.author }}</div>
                  <div class="date">{{ comment?.date }}</div>
                </div>
                <div class="commenter-role">
                  <div>
                    <i
                      class="small circle icon"
                      [ngClass]="{
                        preparer: comment?.role === 'Preparer',
                        reviewer: comment?.role === 'Reviewer'
                      }"
                    ></i>
                    {{ comment?.role }}
                  </div>
                </div>
                <div class="comment-text">
                  <app-comment
                    [comment]="comment"
                    [documents]="taxReturn.documents"
                  ></app-comment>
                </div>
              </div>
              }
              <div class="reply-comment">
                @if (!readonly() && answerFlag.replyTo) {
                <div>
                  <app-attachments
                    [(ngModel)]="answerFlag.replyComment"
                  ></app-attachments>
                  <span
                    (click)="cancelReply(answerFlag)"
                    class="cancel-reply"
                    >{{ "taxReturns.cancel" | transloco }}</span
                  >
                  <span
                    (click)="replyToFlag(answerFlag)"
                    class="reply-only"
                    [ngClass]="{
                      disabled: !answerFlag.replyComment.message || replyingFlag
                    }"
                    >{{ "taxReturns.reply-only" | transloco }}</span
                  >
                  <div
                    (click)="replyToFlag(answerFlag, true)"
                    class="ui primary background button"
                    [ngClass]="{
                      disabled: !answerFlag.replyComment.message || replyingFlag
                    }"
                  >
                    {{ "taxReturns.reply-and-close" | transloco }}
                  </div>
                </div>
                }
              </div>
            </div>
            <div class="buttons">
              @if (!readonly() && answerFlag?.status === 0 &&
              !answerFlag.replyTo) {
              <span (click)="answerFlag.replyTo = true" class="respond">{{
                "taxReturns.reply" | transloco
              }}</span>
              } @if (showSendToClientButton(answerFlag, question)) {
              <div class="send-to-client">
                <i class="arrow up icon"></i>
                <span>{{ "taxReturns.Send-to-Client" | transloco }}</span>
              </div>
              }
              <!-- <div *ngIf="answerFlag.externalUrl" class="view-in-oneteam">
                    <i class="external alternate icon"></i> <a [href]="answerFlag.externalUrl" target="_blank">{{ 'taxReturns.View-in-OneTeam' | transloco }}</a>
                  </div> -->
            </div>
          </div>
          }
        </ng-container>
      </div>
    </div>
  </div>
  }
</div>
} @if (taxReturnWithMissingInfo && tab === 3) {
<div class="body">
  @if (( taxReturnWithMissingInfo && taxReturnWithMissingInfo.categories.length
  === 0) || !hasWarnings) {
  <div class="no-warnings-info">{{ "taxReturns.no-warnings" | transloco }}</div>
  }
  <div class="left-bar">
    @for (category of taxReturnWithMissingInfo.categories; track category) {
    <div class="category">
      @if (showitem(category, tab)) {
      <div class="count">
        <div
          class="title"
          (click)="category.isCollapsed = !category.isCollapsed"
        >
          <i
            class="chevron icon"
            [ngClass]="{
              down: category.isCollapsed,
              up: !category.isCollapsed
            }"
          ></i>
          {{ category.name }}
        </div>
        @for (subCategory of category.subcategories; track subCategory) {
        <div [hidden]="category.isCollapsed" class="subcategory">
          @if (showitem(subCategory, tab)) {
          <div>
            <div
              class="title"
              (click)="subCategory.isCollapsed = !subCategory.isCollapsed"
            >
              <i
                class="chevron icon"
                [ngClass]="{
                  down: subCategory.isCollapsed,
                  up: !subCategory.isCollapsed
                }"
              ></i>
              {{ subCategory.name }}
            </div>
            @for (group of subCategory.groups; track group) {
            <div [hidden]="subCategory.isCollapsed" class="group">
              @if (showitem(group, tab)) {
              <div>
                @if (group.id) {
                <div
                  class="title"
                  (click)="group.isCollapsed = !group.isCollapsed"
                >
                  <i
                    class="chevron icon"
                    [ngClass]="{
                      down: group.isCollapsed,
                      up: !group.isCollapsed
                    }"
                  ></i>
                  {{ group.name }}
                </div>
                } @for (subGroup of group.subgroups; track subGroup) {
                <div [hidden]="group.isCollapsed" class="subgroup">
                  @if (showitem(subGroup, tab) && !subGroup.isTable) {
                  <div>
                    <div
                      class="title"
                      (click)="subGroup.isCollapsed = !subGroup.isCollapsed"
                    >
                      <i
                        class="chevron icon"
                        [ngClass]="{
                          down: subGroup.isCollapsed,
                          up: !subGroup.isCollapsed
                        }"
                      ></i>
                      {{ subGroup.name }}
                    </div>
                    @for (_question of subGroup.questions; track _question) {
                    <div [hidden]="subGroup.isCollapsed">
                      @if (hasMissingInfoWarnings(category, _question, tab)) {
                      <div
                        class="question"
                        [ngClass]="{
                          active:
                            _question.id === question?.id &&
                            question.category?.id === category?.id &&
                            question.subcategory?.id === subCategory?.id &&
                            (group.id
                              ? question.group?.id === group?.id
                              : true) &&
                            question.subgroup?.id === subGroup?.id
                        }"
                      >
                        <span
                          (click)="
                            selectQuestion(
                              _question,
                              category,
                              subCategory,
                              group,
                              subGroup,
                              tab
                            )
                          "
                        >
                          {{ _question.id }}.&nbsp;{{ _question.question }}
                        </span>
                        @if ( _question.id===question?.id &&
                        question.category?.id===category?.id &&
                        question.subcategory?.id===subCategory?.id && (group.id
                        ? question.group?.id===group?.id : true) &&
                        question.subgroup?.id===subGroup?.id) {
                        <span
                          (click)="
                            goToSection(
                              _question,
                              category,
                              subCategory,
                              group,
                              subGroup
                            )
                          "
                        >
                          &#8618;
                          {{ "taxReturns.go-to-section-no-arrow" | transloco }}
                        </span>
                        }
                      </div>
                      }
                    </div>
                    }
                  </div>
                  } @if (showitem(subGroup, tab) && subGroup.isTable) {
                  <div>
                    <div
                      class="title"
                      (click)="subGroup.isCollapsed = !subGroup.isCollapsed"
                    >
                      <i
                        class="chevron icon"
                        [ngClass]="{
                          down: subGroup.isCollapsed,
                          up: !subGroup.isCollapsed
                        }"
                      ></i>
                      {{ subGroup.name }}
                    </div>
                    <div [hidden]="subGroup.isCollapsed">
                      <div
                        class="question"
                        [ngClass]="{
                          active:
                            subGroup.question.id === question?.id &&
                            question.category?.id === category?.id &&
                            question.subcategory?.id === subCategory?.id &&
                            (group.id
                              ? question.group?.id === group?.id
                              : true) &&
                            question.subgroup?.id === subGroup?.id
                        }"
                      >
                        <span
                          (click)="
                            selectQuestion(
                              subGroup.question,
                              category,
                              subCategory,
                              group,
                              subGroup,
                              tab
                            )
                          "
                        >
                          {{ subGroup.question.id }}.&nbsp;{{
                            subGroup.question.question
                          }}
                        </span>
                        @if ( subGroup.question.id===question?.id &&
                        question.category?.id===category?.id &&
                        question.subcategory?.id===subCategory?.id && (group.id
                        ? question.group?.id===group?.id : true) &&
                        question.subgroup?.id===subGroup?.id) {
                        <span
                          (click)="
                            goToSection(
                              subGroup.question,
                              category,
                              subCategory,
                              group,
                              subGroup
                            )
                          "
                        >
                          &#8618;
                          {{ "taxReturns.go-to-section-no-arrow" | transloco }}
                        </span>
                        }
                      </div>
                    </div>
                  </div>
                  }
                </div>
                }
              </div>
              }
            </div>
            }
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
  @if (question && hasWarnings) {
  <div class="main-content">
    <header>
      <h3>{{ question?.id }}.&nbsp;{{ question?.question }}</h3>
    </header>
    <div class="list-container">
      <div class="list-inner-cont">
        @if (question.displayFieldType !== 'table' && !question.parentId) {
        <div class="display-answer">
          @if (question) {
          <app-form-field-wrapper
            [disabled]="true"
            [formGroup]="formGroup"
            [question]="question"
            [showHiddenQuestion]="true"
          >
          </app-form-field-wrapper>
          }
        </div>
        } @if (question.displayFieldType === 'table') {
        <div class="display-answer">
          <app-modern-table
            [columnOrdering]="columnOrdering"
            [subGroup]="subGroup"
            [formGroup]="formGroup"
            [groupId]="groupId"
            [readonly]="true"
            [taxReturnId]="taxReturnId"
            [isVisible]="true"
            [hideFullScreen]="true"
          >
          </app-modern-table>
        </div>
        } @if (question.validationWarning) {
        <div class="flag-item">
          <div class="comment">
            <div class="header">
              <div class="ui label">{{ "taxReturns.warning" | transloco }}</div>
            </div>
            <div class="labels">
              <div class="ui label">
                {{ question?.id }}.&nbsp;{{ question?.question }}
              </div>
            </div>
            @if (question?.validationWarning?.warningMessage) {
            <div class="answer label">
              {{ question?.validationWarning?.warningMessage }}
            </div>
            }
          </div>
        </div>
        }
        <div id="comments-list-container">
          <div id="comments">
            <div class="flex-aligner"></div>
            <ng-template
              #commentTemplate
              let-comment="comment"
              let-isParent="isParent"
              let-index="index"
            >
              <div class="comment" [ngClass]="{ reply: !isParent }">
                <div class="commenter-name">{{ comment?.author }}</div>
                <div class="commenter-role">
                  <div>
                    <i
                      class="small circle icon"
                      [ngClass]="{
                        preparer: comment?.role === 'Preparer',
                        reviewer: comment?.role === 'Reviewer'
                      }"
                    ></i>
                    {{ comment?.role }}
                  </div>
                  <div class="comment-date">{{ comment?.date }}</div>
                </div>
                <div class="comment-labels">
                  @if (isParent) { @for (field of comment.commentFields; track
                  field) {
                  <div
                    class="field-label ui label"
                    [matTooltip]="field.tooltipConent"
                    matTooltipPosition="above"
                  >
                    @if (showQuestionId) {
                    <span>{{ field?.id }}.</span>
                    } {{ field?.question }}
                  </div>
                  } }
                </div>
                <div class="comment-text">
                  <app-comment
                    [comment]="comment"
                    [documents]="documents"
                  ></app-comment>
                </div>
                @if (isParent) { @for (reply of comment.comments; track reply) {
                <div>
                  <ng-container
                    *ngTemplateOutlet="
                      commentTemplate;
                      context: { comment: reply, isParent: false }
                    "
                  >
                  </ng-container>
                </div>
                }
                <div class="reply-comment">
                  @if (comment.replyTo) {
                  <div>
                    <app-attachments
                      [(ngModel)]="comment.replyComment"
                    ></app-attachments>
                    <span (click)="cancelReply(comment)" class="cancel-reply">{{
                      "taxReturns.cancel" | transloco
                    }}</span>
                    <div
                      (click)="saveCommentReply(comment)"
                      class="ui primary background button"
                      [ngClass]="{
                        disabled: !comment.replyComment,
                        loading: isSavingReply
                      }"
                    >
                      {{ "taxReturns.post" | transloco }}
                    </div>
                  </div>
                  }
                </div>
                @if (!readonly() && !comment.replyTo) {
                <span (click)="comment.replyTo = true" class="reply-btn">{{
                  "taxReturns.reply" | transloco
                }}</span>
                } }
              </div>
            </ng-template>
            @for (commentItem of comments|orderBy:['dateMoment']:['asc']; track
            commentItem; let index = $index) {
            <ng-container
              *ngTemplateOutlet="
                commentTemplate;
                context: { comment: commentItem, isParent: true, index: index }
              "
            >
            </ng-container>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>
}
